import { render } from "./EmailsList.vue?vue&type=template&id=58620af7&scoped=true"
import script from "./EmailsList.vue?vue&type=script&lang=js"
export * from "./EmailsList.vue?vue&type=script&lang=js"

import "./EmailsList.vue?vue&type=style&index=0&id=58620af7&lang=sass&scoped=true"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58620af7"]])

export default __exports__